import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { DownloadedFile } from '../Interfaces/demand-export.interface';
import { parseContentDispositionFilename } from './report-file.util';

export function requestFileDownload(http: HttpClient, url: string): Observable<DownloadedFile> {
  return http
    .get(url, {
      observe: 'response',
      responseType: 'blob',
      headers: { 'skip-loading': 'true', 'skip-error': 'true' },
    })
    .pipe(
      map((response) => ({
        blob: response.body as Blob,
        filename: parseContentDispositionFilename(response.headers.get('Content-Disposition')),
      })),
    );
}
